module.exports = __webpack_public_path__ + "img/19@2x.04ca6dd7.png";